<div class="ion-text-center ion-padding pop-header">
  <ion-text>ACTIVAR ALERTA</ion-text>
</div>
<ion-list>
  <ion-item *ngFor="let alert of alerts" >
    <ion-label>{{alert.descripcion}}</ion-label>
    <ion-checkbox slot="end" [(ngModel)]="alert.isActive"></ion-checkbox>
  </ion-item>
</ion-list>

<ion-row>
  <ion-col class="ion-no-padding">
    <ion-button class="ion-no-margin" (click)="activateAlert()" expand="full" fill="clear">Guardar</ion-button>
  </ion-col>
  <ion-col class="ion-no-padding">
    <ion-button (click)="dismissModal()" class="ion-no-margin" expand="full" fill="clear">Cancelar</ion-button>
  </ion-col>
</ion-row>
